module.exports = __webpack_public_path__ + "img/19b-doc-publicacoes-show.7987a76b.png";